import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { WaterMeterChangeModel } from "@/core/models/water-meter-change.model";

export interface WaterMeterChangeQueryParams {
    search?: string;
    waterUserId?: string;
    tollAreaId?: string;
    year?: number | string;
    month?: number | string;
    fromDate?: string;
    toDate?: string;
    status?: string;
    reason?: string;
}

@injectable()
export class WaterMeterChangeRepo extends TableRepo<WaterMeterChangeModel> {
    protected getPagePath = "changes/page";

    constructor() {
        super("/api/WaterMeter");
    }

    async getData(
        index: number,
        params: WaterMeterChangeQueryParams,
        pageSize = 10
    ): Promise<ApiPage<WaterMeterChangeModel> | null> {
        return await super.getData(index, params, pageSize);
    }

    async exportChangesExcel(params: object) {
        try {
            const response = await this.apiRepo.getBlob(
                `${this.basepath}/changes/export-excel`,
                params
            );
            return response;
        } catch (err) {
            console.log(err);
            return null;
        }
    }
}
